import { useState, useEffect, useRef } from 'react';

const useOptions = ({ getOptionsApi, isFetchOnMount = false }) => {
    const [options, setOptions] = useState({});

    const isOptionsLoadingRef = useRef(false);

    const fetchOptions = async (...args) => {
        if (isOptionsLoadingRef.current) return;

        isOptionsLoadingRef.current = true;
        try {
            const resp = await getOptionsApi(...args);
            if (resp) setOptions(resp);
        } catch (error) {
            console.error('Failed to fetch options:', error);
            setOptions({});
        } finally {
            isOptionsLoadingRef.current = false;
        }
    };

    useEffect(
        () => {
            if (typeof getOptionsApi === 'function' && isFetchOnMount) fetchOptions();
        },
        // eslint-disable-next-line
        [isFetchOnMount],
    );

    return {
        options,
        getOptionsApi: fetchOptions,
    };
};

export default useOptions;
